// extracted by mini-css-extract-plugin
export default {"eventDateContainer":"Gzhwdgn4czsoGJfP4wDD","calendarIcon":"qcOpLbGxE0kLmWyTJ_X4"};